"use strict";
// Copyright (C) 2017-2025 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ratings = void 0;
var Ratings_1 = __importDefault(require("./Ratings"));
exports.Ratings = Ratings_1.default;
